import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Extracts a clean, user-facing message from a caught Convex mutation
 * error. A ConvexError's .message on the client is wrapped in technical
 * noise ("[CONVEX M(...)] [Request ID: ...] Server Error Uncaught
 * ConvexError: ... at handler (...)"), but its .data property still holds
 * exactly the string that was passed to `throw new ConvexError(...)` on the
 * server, untouched by that wrapping. Falls back to a generic message for
 * anything else (network errors, unexpected exceptions) rather than ever
 * surfacing raw stack/debug text to a user.
 */
export function getErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (error && typeof error === 'object' && 'data' in error && typeof (error as { data: unknown }).data === 'string') {
    return (error as { data: string }).data
  }
  if (error instanceof Error && error.message) {
    return error.message
  }
  return fallback
}
